<template>
  <div class="courses">
    <template v-if="chunks.length">
      <transition-group name="bounce">
        <template v-for="(chunk,key) in chunks">
          <el-row :gutter="20" class="courses-list" :key="key + 1" v-if="(key + 1) < currentPage * 5">
            <el-col class="courses-list__item" :lg="lg" :md="24" :sm="24" :xs="24" v-for="course in chunk" :key="course.id">
              <course-card :key="course.id" :course="course" />
            </el-col>
          </el-row>
        </template>
      </transition-group>
    </template>
    <template v-else-if="filtersNotEmpty && orderedCourses && !orderedCourses.length">
      <div class="text-center">
        <button @click="clear()" class="btn btn-lg btn-without-border color-grey lg-visible">
        <span class="d-flex align-center">
          <span>{{ $t('course.nothingFound') }}</span>
        </span>
        </button>
      </div>
    </template>
    <template v-else>
      <transition>
        <course-list-preloader />
      </transition>
    </template>
    <div v-if="pagination && totalPages > currentPage" class="mt-24 d-flex justify-center">
      <button @click="++currentPage" class="btn btn-lg">
        <span class="d-flex align-center">
          <img src="../../assets/icons/recover.svg" />
          <span>{{ $t('buttons.showMore') }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import CourseCard from "./CourseCard.vue";
import _ from 'lodash';
import {eventBus} from "../../main";
import CourseListPreloader from "./CourseListPreloader.vue";
import sizeMixin from "../../mixin/sizeMixin";
export default {
  name: "CourseList",
  components: {CourseListPreloader, CourseCard},
  mixins: [sizeMixin],
  data() {
    return {
      chunks: [],
      currentPage: 1
    }
  },
  props: {
    courses: {
      type: Array,
      default() {
        return null
      }
    },
    filters: {
      type: Object,
      default() {
        return {
          categories: [],
          title: null
        }
      }
    },
    pagination: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  mounted() {
    this.load()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        if(this.windowWidth !== document.documentElement.clientWidth) {
          this.load()
        }
      });
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.load);
  },
  methods: {
    clear() {
      eventBus.$emit('filters:clear')
    },
    load() {
      this.currentPage = 1
      this.chunks = []
      this.chunks = _.chunk((this.orderedCourses), this.size())
      this.windowWidth = window.innerWidth
    },
    searchByTitle(courses) {
      return courses.filter(course => {
        if(!course.name || !course.shortDescription) {
          return false;
        }
        return course.name.toLowerCase().indexOf(this.filters.title.toLowerCase()) > -1 || course.shortDescription.toLowerCase().indexOf(this.filters.title.toLowerCase()) > -1;
      })
    },
    searchByCategory(courses) {
      return courses.filter(course => {
        if(course.category) {
          return this.filters.categories.indexOf(course.category.id) > -1
        }
        return false;
      })
    }
  },
  computed: {
    totalPages() {
      return Math.round(this.chunks.length/5)
    },
    filtersNotEmpty() {
      return this.filters.title || this.filters.categories.length;
    },
    orderedCourses: function () {
      let courses = _.orderBy(this.courses, ['cost', 'status', 'endDateTime', 'name'], ['asc','desc','asc','asc']).filter(course => {
        return course.isActive && course.shortDescription;
      });
      if(this.filters.title && this.filters.categories.length) {
        return _.intersection(this.searchByTitle(courses), this.searchByCategory(courses))
      } else if(this.filters.title) {
        return this.searchByTitle(courses)
      } else if(this.filters.categories.length) {
        return this.searchByCategory(courses)
      }
      return this.courses;
    },
  },
  watch: {
    courses() {
      this.load()
    },
    orderedCourses() {
      this.load()
    },
    filters() {
      this.load()
    }
  }
}
</script>